// Open-redirect guard: only a plain same-site absolute path passes. `//` is protocol-relative,
// browsers normalize `\` to `/` (so `/\evil.com` becomes `//evil.com`), and URL parsers strip
// tab/newline BEFORE parsing (so `/\t/evil.com` becomes `//evil.com` past a naive prefix check).
// Literal spaces stay allowed: parsers don't strip them and a decoded %20 is legitimate.
const ASCII_CONTROL_CHARS = /[\u0000-\u001F\u007F]/

export function getSafeRedirect(fallback: string): string {
  const redirect = new URLSearchParams(window.location.search).get('redirect')

  if (
    redirect &&
    redirect.startsWith('/') &&
    !redirect.startsWith('//') &&
    !redirect.includes('\\') &&
    !ASCII_CONTROL_CHARS.test(redirect)
  ) {
    return redirect
  }

  return fallback
}
